module.exports = __webpack_public_path__ + "static/media/DIBAHUC_history.2afd6ea2.png";